module.exports = __webpack_public_path__ + "img/product_78.4fdd3ee.webp";